import React from 'react';
import { useLocation } from 'react-router-dom';
import Dashboard from './Dashboard';
import DeviceDetails from './DeviceDetails';
import '../App.css';

const DashboardLayout = () => {
  const location = useLocation();
  const isDeviceDetails = location.pathname.startsWith('/device/');
  
  return (
    <div className="dashboard-layout" style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Keep Dashboard mounted but hidden when on device details */}
      {/* This preserves scroll position and prevents remounting */}
      <div 
        className={isDeviceDetails ? 'dashboard-hidden' : 'dashboard-visible'}
        style={{ 
          display: isDeviceDetails ? 'none' : 'block',
          width: '100%',
          height: '100%'
        }}
      >
        <Dashboard />
      </div>
      
      {/* Show DeviceDetails when on device route */}
      <div 
        className={isDeviceDetails ? 'device-details-visible' : 'device-details-hidden'}
        style={{ 
          display: isDeviceDetails ? 'block' : 'none',
          width: '100%',
          height: '100%',
          position: isDeviceDetails ? 'relative' : 'absolute',
          top: 0,
          left: 0
        }}
      >
        {isDeviceDetails && <DeviceDetails />}
      </div>
    </div>
  );
};

export default DashboardLayout;
